/* eslint-disable no-template-curly-in-string */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import {
    Form, FormGroup, FormControl, ControlLabel, Alert,
    Modal, Button, Uploader, SelectPicker, Table, Toggle
} from 'rsuite';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Signs from '../../services/signs';
import { baseUrl, linkUrl } from '../../services/abstract';
import _ from 'lodash';
import SIGN_STATUS from '../../constants/signs/statuses';
import { disableInput } from '../../helpers/styless/Inputs';
import ENABLE from '../../constants/enable';

const initialMetadata = {
    code: '',
    attempt: '',
    message: '',
    created_at: ''
};

const toggleSize = {
    lg: 'lg',
    md: 'md',
    sm: 'sm'
};

const genderData = [
    { label: 'Masculino', value: 'M' },
    { label: 'Femenino', value: 'F' }
];

export default function ViewUserDialog ({ show, onHide, id }) {
    // Form values states
    const [document, setDocument] = useState('');
    const [name, setName] = useState('');
    const [lastname, setLastname] = useState('');
    const [gender, setGender] = useState('');
    const [change, setChange] = useState(false);
    const [hash, setHash] = useState('');
    // for list of error
    const [failureReason, setFailureReason] = useState(initialMetadata);
    const [metadata, setMetadata] = useState(initialMetadata);
    const [showFailureReason, setShowFailureReason] = useState(false);

    const [status, setStatus] = useState('');
    const [filesList, setFilesList] = useState([]);
    const [filesDeleted, setFilesDeleted] = useState([]);
    const [pending, setPending] = useState(false);
    const [copy, setCopy] = useState({ value: '', copied: false });
    // Loading state
    const [isLoading, setIsLoading] = useState(false);

    function getAttributeValue (attributes, description) {
        const attribute = _.find(attributes, ['description', description]);
        return attribute ? attribute.value : '';
    };

    function getdni (personDocuments) {
        if (!personDocuments || !personDocuments[0]) return '';
        const dni = _.find(personDocuments, function (d) { return d.type.id === 1; });
        return dni ? dni.description : '';
    };

    function getUser () {
        setIsLoading(true);
        return Signs
            .getById(id)
            .then(response => {
                setName(getAttributeValue(response.person.attributes, 'first_name'));
                setLastname(getAttributeValue(response.person.attributes, 'last_name'));
                setGender(getAttributeValue(response.person.attributes, 'gender'));
                setDocument(getdni(response.person.documents));
                setHash(response.hash);
                setPending([SIGN_STATUS.PENDING, SIGN_STATUS.FAIL].includes(response.id_cuotitas_request_status));
                setStatus(response.id_cuotitas_request_status);
                setFilesList(response.request_files.map(file => {
                    file.name = file.file.metadata.filename;
                    file.fileKey = file.file.id;
                    file.url = file.file.description;
                    return file;
                }));
                // Auxiliar function
                const pepareSigError = (signError) => ({
                    code: signError?.code || 'S/D',
                    attempt: signError?.attempt || 'S/D',
                    message: signError?.message || 'S/D',
                    created_at: signError?.created_at ? `${new Date(signError?.created_at).toLocaleDateString()}` : 'S/D',
                    time: signError?.created_at ? `${new Date(signError?.created_at).toLocaleTimeString()}` : 'S/D'
                });
                // Only if signs is failed
                if (response.id_cuotitas_request_status === SIGN_STATUS.FAIL || response.id_cuotitas_request_status === SIGN_STATUS.CANCELLED) {
                    const metadataError = _.first(response?.metadata?.errors) || response?.metadata?.error;
                    // for old errors
                    setFailureReason(pepareSigError(metadataError));
                    // for new list of error
                    if (response?.metadata?.errors?.length) {
                        response.metadata.errors = response?.metadata?.errors.map(e => pepareSigError(e));
                    }

                    setMetadata(response.metadata);
                }
            })
            .catch(e => {
                console.error(e);
                Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
            })
            .finally(() => setIsLoading(false));
    };

    function updateUser () {
        if (!name.trim()) {
            return Alert.error('El nombre es obligatorio');
        }

        if (!lastname.trim()) {
            return Alert.error('El apellido es obligatorio');
        }

        if (!['M', 'F'].includes(gender)) {
            return Alert.error('Por favor, seleccione un género para la persona.');
        }

        if (!document.trim()) {
            return Alert.error('El género es obligatorio');
        }

        if (filesList.length === 0) {
            return Alert.error('Debe existir al menos un archivo cargado');
        }

        setIsLoading(true);

        var form = new FormData();

        form.append('person.attributes[0].description', 'first_name');
        form.append('person.attributes[0].value', name);
        form.append('person.attributes[1].description', 'last_name');
        form.append('person.attributes[1].value', lastname);
        form.append('person.attributes[2].description', 'gender');
        form.append('person.attributes[2].value', gender);
        form.append('person.documents[0].document', document);
        form.append('person.documents[0].idType', '1');
        form.append('person.idType', '1');
        filesList.forEach((file, index) => {
            if (!file.id) {
                form.append(`file${filesList.length}`, file.blobFile);
            }
        });
        filesDeleted.forEach((file) => {
            form.append('remove[0]', file);
        });
        return Signs
            .upDateUser(form, id)
            .then(result => Alert.success('El usuario se actualizó correctamente.', 5000))
            .then(() => {
                setPending(false);
                setDocument('');
                setName('');
                setLastname('');
                setGender('');
                setChange(false);
                setFilesList([]);
                onHide();
            })
            .catch(e => {
                console.error(e);
                Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    function handleDownload (file) {
        return Signs
            .downloadFile(file.id, file.file.id)
            .then(data => {
                Alert.success('El archivo se descargara pronto', 5000);
                window.open(`${baseUrl}/signs/signs/cuotitas/requestsFiles/${file.id}/files/${file.file.id}/download`);
            })
            .catch(e => {
                console.error(e);
                Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
                onHide();
                setIsLoading(false);
            });
    };

    async function upDateUser () {
        if (!change) {
            onHide();
            setPending(false);
            setDocument('');
            setName('');
            setLastname('');
            setGender('');
            setChange(false);
            setFilesList([]);
            return;
        }
        await updateUser();
    };

    function handleChange (file) {
        setChange(true);
        setFilesList(file);
    };

    function handleRemove (file) {
        const filesDelete = filesDeleted;
        filesDelete.push(file.id);
        const files = filesList.filter(item => file.name !== item.name);
        setChange(true);
        setFilesList(files);
        setFilesDeleted(filesDelete);
    };

    function handleAnular () {
        return Signs
            .anular(id)
            .then(response => {
                Alert.success('El contrato fue anulado correctamente.', 5000);
                onHide();
            })
            .catch(e => {
                console.error(e);
                Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
                onHide();
                return false;
            });
    };

    useEffect(() => {
        if (show === true) {
            getUser();
        }
    }, [show]);

    return (
        <Modal
            show={show}
            onHide={onHide}
            className={`${show ? 'show in' : ''}`}
            aria-labelledby='user-create-modal'
            size='lg'
            keyboard={false}
        >
            <Modal.Header closeButton >
                <Modal.Title id='user-create-modal'>
                    <div className='d-flex justify-content-around'>
                        <span>Solicitud # {id}</span>
                        <div className='d-flex justify-content-around'>
                            <span className='my-auto'>{linkUrl}/{hash} </span>
                            <div>
                                {status !== 2 && <CopyToClipboard text={`${linkUrl}/${hash}`}
                                    onCopy={() => setCopy({ copied: true })}>
                                    {status === 4
                                        ? <Button color='red' className="pl-4 ml-2" readOnly>Anulado</Button>
                                        : <Button color={copy.copied ? 'green' : 'blue'} className="pl-4 ml-2">{copy.copied ? 'Copiado' : 'Copiar'}</Button>
                                    }
                                </CopyToClipboard>
                                }
                            </div>
                        </div>
                    </div>
                </Modal.Title>
            </Modal.Header >
            <Modal.Body className='h-75' style={{ overFlow: 'hidden! important' }}>
                {!isLoading && (
                    <div className='row justify-content-center'>
                        <div className='col-md-8'>
                            <Form
                                fluid
                                formValue={{ name, lastname, document, pending }}
                                onChange={setChange}
                            >
                                <FormGroup>
                                    <ControlLabel>Nombre</ControlLabel>
                                    <FormControl
                                        value={name}
                                        onChange={setName}
                                        readOnly={!pending}

                                    />
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>Apellido</ControlLabel>
                                    <FormControl
                                        value={lastname}
                                        onChange={setLastname}
                                        readOnly={!pending}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>GÉNERO</ControlLabel>
                                    <FormControl
                                        placeholder= 'Género'
                                        value={gender}
                                        onChange={setGender}
                                        accepter={SelectPicker}
                                        data={genderData}
                                        style = {{ width: 'inherit' }}
                                    />
                                </FormGroup>
                                <FormGroup />
                                <FormGroup>
                                    <ControlLabel>DNI</ControlLabel>
                                    <FormControl
                                        value={document}
                                        onChange={setDocument}
                                        readOnly
                                        // ='true'
                                    />
                                </FormGroup>
                                {(status === SIGN_STATUS.FAIL || status === SIGN_STATUS.CANCELLED) && <FormGroup>
                                    <ControlLabel>Motivo del rechazo ( cod: {failureReason.code}{ENABLE.enableSignAttempts && `, Nro. de intento: ${failureReason.attempt}`})</ControlLabel>
                                    <FormControl
                                        style={disableInput}
                                        value={failureReason.message}
                                        readOnly
                                    />
                                </FormGroup>}
                                {/* Displayed only if there is a list of errors  */}
                                {(ENABLE.enableSignAttempts && !!metadata?.errors?.length) && <div>
                                    <ControlLabel style={{ marginRight: '40px' }}>Mostrar historial: </ControlLabel>
                                    <Toggle size={toggleSize.md} checkedChildren="Si" unCheckedChildren="No" onChange={() => setShowFailureReason(!showFailureReason)}/>
                                    {/* Show/Hide if the button was pressed */}
                                    {showFailureReason &&
                                        <Table
                                            height={300}
                                            width={600}
                                            rowHeight={60}
                                            wordWrap={true}
                                            virtualized={true}
                                            shouldUpdateScroll={true}
                                            data={metadata.errors}
                                            onRowClick={data => setFailureReason(data)}
                                        >
                                            <Table.Column width={40} resizable={true}>
                                                <Table.HeaderCell>ID</Table.HeaderCell>
                                                <Table.Cell dataKey="attempt" />
                                            </Table.Column>

                                            <Table.Column width={90} resizable>
                                                <Table.HeaderCell>Código</Table.HeaderCell>
                                                <Table.Cell dataKey="code" />
                                            </Table.Column>

                                            <Table.Column width={300} resizable>
                                                <Table.HeaderCell>Descripción</Table.HeaderCell>
                                                <Table.Cell dataKey="message" />
                                            </Table.Column>

                                            <Table.Column width={90} resizable>
                                                <Table.HeaderCell>Fecha</Table.HeaderCell>
                                                <Table.Cell dataKey="created_at" />
                                            </Table.Column>

                                            <Table.Column width={85} resizable>
                                                <Table.HeaderCell>Hora</Table.HeaderCell>
                                                <Table.Cell dataKey="time" />
                                            </Table.Column>
                                        </Table>}
                                </div>}
                                <FormGroup>
                                    <ControlLabel>Cargar archivos</ControlLabel>
                                    <Uploader
                                        multiple
                                        disabled={isLoading}
                                        fileList={filesList}
                                        autoUpload={false}
                                        onRemove={file => handleRemove(file)}
                                        onChange={files => handleChange(files)}
                                        onPreview={file => handleDownload(file)}
                                        readOnly={!pending}
                                    >
                                        <div style={{ lineHeight: 4 }}>Haga Click para cargar sus archivos</div>
                                    </Uploader>
                                </FormGroup>

                            </Form>
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer className='mt-4'>
                <div className='d-flex justify-content-around'>
                    {pending && <Button color='yellow' disabled={isLoading} onClick={handleAnular} >Anular</Button>}
                    <div>
                        {pending
                            ? <Button appearance='primary' loading={isLoading} onClick={upDateUser} >{!change ? 'Aceptar' : 'Guardar'}</Button>
                            : <Button appearance='primary' loading={isLoading} onClick={onHide} >Aceptar</Button>
                        }
                        <Button disabled={isLoading} onClick={onHide} >Cancelar</Button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );
};
